import React, { useContext, createContext } from 'react'
import { initAuthFrontLock, IAuthFrontLock } from '@cimpress-technology/authfront-lock-sdk'

type Props = {
    children: React.ReactNode;
};

type AuthFrontLockContextType = {
    authFrontLock: IAuthFrontLock | undefined
}

const AuthFrontLockContext = createContext<AuthFrontLockContextType | null>(null)

const AuthFrontLockProvider: React.FC<Props> = ({ children }) => {
    const authFrontLock = initAuthFrontLock()
    return (
        <AuthFrontLockContext.Provider value={{ authFrontLock }}>
            {children}
        </AuthFrontLockContext.Provider>

    )
}

const useAuthFrontLock = (): IAuthFrontLock => {
    const context = useContext(AuthFrontLockContext)
    if (context === undefined || context?.authFrontLock === undefined) {
        throw new Error('useAuthFrontLock must be used within a AuthFrontLockProvider')
    }
    return context.authFrontLock
}

export {
    useAuthFrontLock,
    AuthFrontLockProvider
}
